module.exports = __webpack_public_path__ + "media/images/entera-ae773e08.jpg";